import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { authActions } from 'src/auth';
import Button from 'src/views/components/button';

import './sign-in-page.css';


const SignInPage = ({signInWithGoogle}) => {
  return (
    /* jshint ignore:start */
    <div className="g-row sign-in">
      <div className="g-col">
        <h1 className="sign-in__heading">Please Sign in with:</h1>
        <Button className="sign-in__button" onClick={signInWithGoogle}>Google</Button>
      </div>
    </div>
    /* jshint ignore:end */
  );
};

SignInPage.propTypes = {
  signInWithGoogle: PropTypes.func.isRequired,
};


//=====================================
//  CONNECT
//-------------------------------------

const mapDispatchToProps = {
  signInWithGoogle: authActions.signInWithGoogle,
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(SignInPage)
);



// WEBPACK FOOTER //
// ./src/views/pages/sign-in/sign-in-page.js